import React, { ReactNode } from 'react';
import ReactModal from 'react-modal';
import styled from 'styled-components';

const modalStyles = {
  overlay: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'rgba(0,0,0,.85)',
  },
  content: {
    position: 'relative',
    margin: '0 auto',
  },
};

interface ModalProps {
  header: ReactNode | string;
  content: ReactNode;
  actions?: ReactNode;
  isOpen: boolean;
  handleClose: () => void;
}

export const Modal = ({ header, content, actions, handleClose, isOpen }: ModalProps) => {
  const renderActions = () => {
    if (actions) {
      return actions;
    }
    return (
      <div className='ui button' onClick={handleClose}>
        Fechar
      </div>
    );
  };

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={handleClose}
      className='ui modal active'
      ariaHideApp={false}
      style={modalStyles}
    >
      <CloseButton className='ui right floated button' onClick={handleClose}>
        <i className='fa fa-close' />
      </CloseButton>
      <div className='header'>{header}</div>
      <Content className='content'>{content}</Content>
      <div className='actions'>{renderActions()}</div>
    </ReactModal>
  );
};

const CloseButton = styled.div`
  background-color: transparent !important;
`;

const Content = styled.div`
  overflow-y: scroll;
  max-height: 60vh;
`;
